import EvidenceLinkBrowser from './EvidenceLinkBrowser'

/** Investigation case modal — thin wrapper around shared EvidenceLinkBrowser. */
export default function LinkTransactionModal({
  caseId,
  isOpen,
  onClose,
  onAdded,
  defaultMemberId = '',
  defaultMemberName = '',
  defaultEgmHouseNo = '',
}) {
  if (!caseId) return null

  return (
    <EvidenceLinkBrowser
      display="modal"
      isOpen={isOpen}
      onClose={onClose}
      onLinked={onAdded}
      context={{ type: 'investigation_case', id: caseId }}
      defaultMemberNumber={defaultMemberId}
      defaultMemberName={defaultMemberName}
      defaultEgmHouseNo={defaultEgmHouseNo}
      showCsvTab
    />
  )
}
